import Vue from 'vue'
import {
  Button,
  Header,
  Container,
  Menu,
  MenuItem,
  Aside,
  Main,
  Footer,
  Message,
  MessageBox,
  Table,
  TableColumn,
  Pagination,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  Submenu,
  Input,
  Radio,
  Form,
  FormItem,
  Dialog,
  Tabs,
  TabPane,
  Option,
  OptionGroup,
  Select,
  Checkbox,
  Upload,
  Collapse,
  CollapseItem,
  InfiniteScroll,
  Alert,
  Popover,
  Image
} from 'element-ui'
Vue.use(Image)
Vue.use(Popover)
Vue.use(InfiniteScroll)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Submenu)
Vue.use(DropdownItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Pagination)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Header)
Vue.use(Container)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Alert)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
